import pako from "pako"

// // Функция сжатия сообщения
// export async function compressMessage(message) {
//     const encoder = new TextEncoder();
//     const data = encoder.encode(message);
//     const originalSize = data.length;
//     //console.log(`📏 Исходный размер: ${originalSize} байт`);
//
//
//     //const stream = new CompressionStream("deflate");
//     //const compressedStream = new Blob([data]).stream().pipeThrough(stream);
//     const compressedStream = await compressData(data)
//
//     const compressedBlob = await new Response(compressedStream).blob();
//     const compressedBuffer = await compressedBlob.arrayBuffer();
//     const compressedSize = compressedBuffer.byteLength;
//
//     const compressionRate = ((1 - compressedSize / originalSize) * 100).toFixed(2);
//     //console.log(`📉 Сжатый размер: ${compressedSize} байт`);
//     //console.log(`⚡ Степень сжатия: ${compressionRate}%`);
//
//     return compressedBuffer;
// }
//
// async function compressData(data) {
//     if ("CompressionStream" in window) {
//         const stream = new CompressionStream("deflate");
//         const blob = new Blob([data]);
//         return blob.stream().pipeThrough(stream);
//     } else {
//         console.warn("CompressionStream не поддерживается, используем pako");
//         const compressedData = pako.deflate(new TextEncoder().encode(data));
//         return new Blob([compressedData]);
//     }
// }
//
// // Функция разжатия сообщения
// // export async function decompressMessage(compressedBuffer) {
// //     const stream = new DecompressionStream("deflate");
// //     const decompressedStream = new Blob([compressedBuffer]).stream().pipeThrough(stream);
// //     const decompressedBlob = await new Response(decompressedStream).blob();
// //     const decompressedBuffer = await decompressedBlob.arrayBuffer();
// //
// //     //console.log(`📏 Разжатый размер: ${decompressedBuffer.byteLength} байт`);
// //     return new TextDecoder().decode(decompressedBuffer);
// // }
//
// export async function decompressMessage(compressedBlob) {
//     try {
//         // Преобразуем Blob в ArrayBuffer
//         const compressedBuffer = await compressedBlob.arrayBuffer();
//
//         // Преобразуем ArrayBuffer в Uint8Array (требуется для pako)
//         const compressedData = new Uint8Array(compressedBuffer);
//
//         // Разжимаем данные с помощью pako
//         const decompressedData = pako.inflate(compressedData);
//
//         // Декодируем разжатые данные в строку
//         return new TextDecoder().decode(decompressedData);
//     } catch (error) {
//         console.error("Ошибка при разжатии данных:", error);
//         return null;
//     }
// }


export async function compressMessage(input) {
    return input;
}

export async function decompressMessage(input) {
    return input;
}
